export default __webpack_public_path__ + "static/media/black_pawn.8d67388e.png";